
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

import SettingsGroup from '../../../views/Settings/Group/index.vue'
import SettingsItem from '../../../views/Settings/Item/index.vue'
import SettingsButton from '../../../views/Settings/Button/index.vue'

@Observer
@Component({
  components: {
    SettingsGroup,
    SettingsItem,
    SettingsButton
  }
})
export default class MySettingsAccount extends Vue {
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
